// import cookingImage from "../../assets/images/becca-tapert-O7sK3d3TPWQ-unsplash.jpg";
import "./Header.scss";

import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import { useEffect, useState } from "react";

import { Link } from "react-router-dom";

export default function Header() {
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    setTimeout(() => setLoader(false), 300);
  }, []);

  return (
    <header className="header">
      <Navbar bg="light" expand="sm">
        <Container className={!loader ? "" : "container--hidden"}>
          {/* <Navbar.Brand href="/">Gabriela T</Navbar.Brand> */}
          <Link to="/" className="header__logo">
            Gabriela T
          </Link>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              {/* <Nav.Link href="/">Home</Nav.Link>
              <Nav.Link href="/projects">Projects</Nav.Link>
              <Nav.Link href="/contact">Contact</Nav.Link> */}
              {/* <Link to="/" className="header__link">
                Home
              </Link> */}
              <a href="/#projects" className="header__link">
                Projects
              </a>
              <a href="/#contact" className="header__link">
                Contact
              </a>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
}
